<template>
  <v-alert v-if="visible" dense text :type="message.type">
    {{ message.message }}
  </v-alert>
</template>

<script>
export default {
  name: "Message",
  props: {
    message: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    visible: true,
  }),

  created() {
    setTimeout(() => (this.visible = false), 5000);
  },
};
</script>
